import { Box, useTheme } from "@mui/material";
import Link from "@tiptap/extension-link";
import UnderlineExtension from "@tiptap/extension-underline";
import { EditorContent, useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import type { FC } from "react";
import { useEffect } from "react";

interface ReadOnlyRichTextInputProps {
  value: string;
}

export const ReadOnlyRichTextInput: FC<ReadOnlyRichTextInputProps> = ({
  value,
}) => {
  const { colors, radius, typography } = useTheme();
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        heading: { levels: [1, 2, 3, 4, 5, 6] },
      }),
      UnderlineExtension,
      Link.configure({
        openOnClick: true,
        HTMLAttributes: { target: "_blank", rel: "noopener noreferrer" },
      }),
    ],
    content: value,
    editable: false,
  });

  useEffect(() => {
    if (editor && editor.getHTML() !== value) {
      editor.commands.setContent(value, false);
    }
  }, [editor, value]);
  return (
    <Box
      sx={{
        background: colors.background.primary,
        borderRadius: radius.md,
        padding: 0,
        minHeight: 24,
        color: colors.text.primary,
        fontFamily: typography.fontFamily,
        fontSize: typography.body1.fontSize,
        lineHeight: 1.5,
      }}
    >
      <EditorContent editor={editor} />
    </Box>
  );
};
